import { type ICouponRepository, type IUpdateCouponWalletUseCase } from '../../../domain/entry.js';

/**
 * Use case for updating coupon wallet data in the store.
 *
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for updating the coupon wallet
 */
export function updateCouponWalletUseCase(couponRepository: ICouponRepository): IUpdateCouponWalletUseCase {
  return {
    execute: ({ couponId, couponIndex, payload }): ReturnType<IUpdateCouponWalletUseCase['execute']> => {
      const isUpdated = couponRepository.updateCouponWallet({ couponId, couponIndex, payload });
      return isUpdated;
    },
  };
}
